import { PAGE_URL } from "@/api/system/param"
import { createTableActionItem, createTableColumn, createTableHeaderButton } from "@/component-create/utils/create-table-column"
import { Table } from "@/component-create/Table"
import { COMMON_ENABEL_STATUS } from "@/constant/system/code"
import { formatter } from "@/utils/common"

type Row = TColumnControls<'rowDelete' | 'rowEdit'>
type Header = THeaderControls<'addFn' | 'editFn' | 'deleteFn'>

export function createTable(
  el: Element,
  row: Row,
  table: Header
) {
    
  const _table = new Table(
    el, 
    column(row), 
    headerButtons(table), 
    { border: true }, 
    PAGE_URL
  )

  return _table
}

function column(rowHandler: Row) {
  const col: TableColumnProp[] = [
    { type: 'selection' },
    { label: '序号', type: 'index', width: '60' },
    createTableColumn('参数名称', 'paramName', '120'),
    createTableColumn('键', 'paramKey', '240', 'center'),
    createTableColumn('值', 'paramValue', '240', 'center'),
    createTableColumn('备注', 'remark', undefined, undefined, { showOverflowTooltip: true }),
    createTableColumn('状态', 'status', '150', 'center',{ formatter: row => formatter(COMMON_ENABEL_STATUS, row.status) }),
    createTableColumn('操作', undefined, '200', 'center', {
      controller: [
        createTableActionItem('编辑', 'Edit', rowHandler.rowEdit),
        createTableActionItem('删除', 'Delete', rowHandler.rowDelete),
      ]
    }),
  ]
  return col
}

/**
 * 表格头部按钮
 */
function headerButtons(table: Header) {
  return [
    createTableHeaderButton('新增', 'primary', 'Plus', table.addFn),
    createTableHeaderButton('编辑', 'primary', 'Edit', table.editFn),
    createTableHeaderButton('删除', 'primary', 'Delete', table.deleteFn),
  ]
} 